import React, { useEffect, useState } from 'react';
import Button from '../../Atoms/Button/Button';
import Modal from '../Modal/Modal';
import _get from 'lodash/get';
import useStore from '../../../store/useStore';
import { OK_TEXT_BTN } from '../../../constants/ContextConstants';
import { WHITE } from '../../../constants/App';

const ErrorModal = ({
  error,
  okText,
  value,
  analytics,
  oldStyleAnalytics,
  updateModal = () => {
    console.log('No update Modal function was provided.');
  },
  onRemoveItems,
  isCloseErrorModal
}: any) => {

  const [showModal, setShowModal] = useState(true);
  const errorDisctionay: any = _get(error, 'response.data.error', null) ?? _get(error, 'error', null);
  const { setAnalyticsProducts, setAttemptTracker, setContextLoader } = useStore();
  const { clearBag = '', removeItemIds = [] } = _get(error, 'response.data.removeItems', {});
  useEffect(() => {
    if (errorDisctionay) {
      if (analytics && oldStyleAnalytics) {
        analytics.loyalErrorHandle(errorDisctionay.message);
      } else {
        setAnalyticsProducts({
          errorMessage: errorDisctionay.message || '',
          errorMessageMW: 1,
          errorMessageEvent: 1,
          parentErrorCode: errorDisctionay.parentCode || '',
          childErrorCode: errorDisctionay.errorCode || '',
          virtualName: 'error warning modal',
        });
        setAttemptTracker([{ name: value, isClickable: true }, { name: 'errorMessage' }]);
      }
    }
  }, [errorDisctionay]);

  useEffect(() => {
    if (isCloseErrorModal) {
      setShowModal(false);
    }
  }, [isCloseErrorModal]);

  const onClose = () => {
    updateModal();
    setAnalyticsProducts({});
    setShowModal(false);
  };

  return (
    <Modal
      data-testauto-id={'errormodal'}
      isShown={showModal}
      isClosebtn={!(removeItemIds?.length > 0)}
      title={errorDisctionay?.title || ''}
      description={errorDisctionay?.message || errorDisctionay?.messageBody || ''}
      onButtonClick={() => {
        if (removeItemIds?.length > 0) {
          setShowModal(false);
        }
        else {
          onClose();
        }
      }}
      isCloseModalOnEscape = {!(removeItemIds?.length > 0)}
    >
      <div>
        <Button testAutoId={OK_TEXT_BTN} className="btn w-100"
          onClick={() => {
            if (removeItemIds.length > 0) {
              onRemoveItems(removeItemIds);
              setContextLoader({
                buttonId: OK_TEXT_BTN,
                isLoading: true,
                animationColor: WHITE,
                ariaLabelText: `${window?.loadingValue}...`
              });
            }
            else {
              onClose();
            }
          }}>
          {errorDisctionay?.button ?? okText}
        </Button>
        {
          clearBag && (
            <Button testAutoId={'clearBagText'} className="secondary__btn secondary__btn--marginTop secondary__btn--white secondary__btn--full-width"
              onClick={() => {
                onClose();
              }}>
              {clearBag}
            </Button>
          )
        }
      </div>
    </Modal>
  );
};

export default ErrorModal;
